<script setup lang="ts">
import CanvasDisplay from '@/components/canvas/CanvasDisplay.vue';
</script>

<template>
  <CanvasDisplay/>
</template>
